
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 28 28","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.167 19.833v3.5c0 .645.522 1.167 1.166 1.167h16.334c.644 0 1.166-.522 1.166-1.167v-3.5a4.667 4.667 0 00-4.666-4.666H5.833a4.667 4.667 0 00-4.666 4.666zM22.148 23.697c-.041.4.242.803.644.803h2.875c.644 0 1.166-.522 1.166-1.167v-3.5a4.667 4.667 0 00-4.666-4.666h-1.13c-.252 0-.39.303-.24.505a6.968 6.968 0 011.37 4.161v3.5c0 .123-.007.245-.02.364zM15.167 8.167a4.667 4.667 0 11-9.334 0 4.667 4.667 0 019.334 0zM16.743 12.772c-.398-.065-.533-.534-.318-.875a6.968 6.968 0 001.075-3.73c0-1.372-.394-2.65-1.075-3.73-.215-.341-.08-.811.318-.876a4.667 4.667 0 110 9.211z"}})])
          )
        }
      }
    